import apiClient from './apiClient';
import { buildUserPrompt } from './aiPrompts';
import type { ChatMessage } from '@/types';

/**
 * AI 旅行服务 — 调用后端 AI Gateway（不含 Secret）
 *
 * 🔐 安全说明：
 *   - 前端只发送用户消息内容
 *   - System Prompt、AI Key、Prompt 模板全部由后端管理
 *   - 前端无法探测、获取、覆盖 System Prompt
 */
export const getTravelAdvice = async (
  userMessage: string,
  conversationHistory: ChatMessage[] = []
): Promise<string> => {
  const messages = [
    ...conversationHistory,
    { role: 'user' as const, content: userMessage },
  ];

  const result = await apiClient.post('/ai/chat', { messages });
  return (result as { reply?: string; content?: string })?.reply || (result as { content?: string })?.content || '';
};

export const sendChatMessage = async (payload: {
  messages?: ChatMessage[];
  [key: string]: unknown;
}): Promise<unknown> => {
  return apiClient.post('/ai/chat', payload);
};

export const listConversations = async (): Promise<unknown> => {
  return apiClient.get('/ai/conversations');
};

export const getConversation = async (id: string): Promise<unknown> => {
  return apiClient.get(`/ai/conversations/${id}`);
};

export const createConversation = async (title: string): Promise<unknown> => {
  return apiClient.post('/ai/conversations', { title });
};

export const deleteConversation = async (id: string): Promise<unknown> => {
  return apiClient.delete(`/ai/conversations/${id}`);
};

// 保留 buildUserPrompt 用于前端参数拼接（不含任何 Secret）
export { buildUserPrompt };

export const generateTrip = async (preferences: Record<string, unknown>): Promise<unknown> => {
  return apiClient.post('/ai/generate-trip', preferences);
};

export default {
  getTravelAdvice,
  sendChatMessage,
  listConversations,
  getConversation,
  createConversation,
  deleteConversation,
  buildUserPrompt,
  generateTrip,
};
